import React from 'react';

import { EmbeddedChat } from '../../pages/Messenger/messenger.styles';
import { IDimeloIdentity, useInitializeChat, useSetChatPageUrl, useSetSignedChatIdentity } from './chat.utils';

export interface IChatProps {
  fullPage?: boolean;
  token?: string;

  customerType: 'consumer' | 'business';
  identity: IDimeloIdentity;
  extraIdentityValues?: { [key: string]: any };
}

const Chat = (props: IChatProps) => {
  if (props.token) {
    // This hook listens to history changes and pushes the current url
    useSetChatPageUrl();

    // Loads the Dimelo tag and sets the required custom variables.
    useInitializeChat('ziggo_selfservice', props.customerType, props.fullPage ? 'chat-container' : undefined);

    useSetSignedChatIdentity(props.identity, props.token, props.extraIdentityValues);
  }

  if (props.fullPage) {
    return <EmbeddedChat id="chat-container" data-testid="chat-container" />;
  }

  return null;
};

export default Chat;
